module.exports = __webpack_public_path__ + "img/broken-img.a9b70a71.svg";